import { Footer } from '@frontend/pole-ui/lib/components/Footer'

export default Footer
